/*
 * @Author: youfanrong 737064439@qq.com
 * @Date: 2025-03-03 08:59:07
 * @LastEditors: youfanrong 737064439@qq.com
 * @LastEditTime: 2025-11-29 18:56:41
 * @FilePath: /bar-front-end/src/api/login/index.ts
 */
import request from '@/axios'
import type { UserType } from './types'
import { FINANCE_API_PREFIX } from '@/constants'

const BASE_URL = `${FINANCE_API_PREFIX}`

// 登录
export const loginApi = (data: UserType): Promise<IResponse<any>> => {
  // return request.post({ url: '/mock/user/login', data })
  // platform=3 表示财务中心,后端据此校验账号是否属于该系统
  return request.post({ url: `${BASE_URL}/login`, data: { ...data, platform: 3 } })
}

// 获取用户信息
export const getUserInfoApi = (): Promise<IResponse<any>> => {
  return request.get({ url: '/barV2/qywx/user/getUserInfo' })
}

// 获取用户信息
export const getCurUserDetailApi = (): Promise<IResponse<any>> => {
  return request.get({ url: `${BASE_URL}/user/getCurUserDetail` })
}

export const loginOutApi = (): Promise<IResponse> => {
  // return request.get({ url: '/mock/user/loginOut' })
  return request.post({ url: `${BASE_URL}/logout` })
}

export const getUserListApi = ({ params }: AxiosConfig) => {
  return request.get<{
    code: string
    data: {
      list: UserType[]
      total: number
    }
  }>({ url: '/mock/user/list', params })
}

// 获取企微ww.register时所需的企业身份参数信息
export const getWechatConfigInfoApi = (params: any): Promise<IResponse<any>> => {
  return request.get({ url: '/barV2/qywx/user/getJssdkConfigInfo', params })
}

// 获取企微ww.register时所需的应用身份参数信息
export const getWechatAgentConfigInfoApi = (params: any): Promise<IResponse<any>> => {
  return request.get({ url: '/barV2/qywx/user/getJssdkAgentConfigInfo', params })
}

// 查询当前用户最新申请单状态
export const getLatestApplyApi = (params: any): Promise<IResponse<any>> => {
  return request.get({ url: '/barV2/qywx/user/register/getLatestApply', params })
}

// 提交用户注册申请单
export const submitApplyApi = (id, data: any): Promise<IResponse<any>> => {
  return request.post({ url: '/barV2/qywx/user/register/submitApply?quid=' + id, data })
}

// 部门树
export const getDepTreeApi = (params: any): Promise<IResponse<any>> => {
  return request.get({ url: '/barV2/qywx/dep/departTree', params })
}
